import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/functions'; 
import 'firebase/compat/analytics'; // Restore Analytics support

// Robust configuration: Support both Vite (import.meta) and Standard (process.env)
const firebaseConfig = {
    apiKey: process.env.FIREBASE_API_KEY || import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: process.env.FIREBASE_AUTH_DOMAIN || import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.FIREBASE_PROJECT_ID || import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: process.env.FIREBASE_STORAGE_BUCKET || import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID || import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.FIREBASE_APP_ID || import.meta.env.VITE_FIREBASE_APP_ID,
    measurementId: process.env.FIREBASE_MEASUREMENT_ID || import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

let db: firebase.firestore.Firestore;
let auth: firebase.auth.Auth;
let functions: firebase.functions.Functions;
let analytics: firebase.analytics.Analytics | null = null;

try {
    if (firebaseConfig.apiKey) {
        // Initialize only if not already initialized
        const app = !firebase.apps.length ? firebase.initializeApp(firebaseConfig) : firebase.app();
        
        db = app.firestore();
        auth = app.auth();
        
        // Initialize Cloud Functions with specific region 'asia-south1'
        functions = app.functions('asia-south1'); 
        
        // Initialize Analytics if supported (Client-side only)
        if (typeof window !== 'undefined') {
            analytics = app.analytics();
        }

        // Local Development: Connect to Firebase Emulators
        if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
            console.log("🔧 Connecting to Firebase Emulators");
            functions.useEmulator("127.0.0.1", 5001); 
            // Optional: Connect Auth/Firestore emulators if you use them locally
            // db.useEmulator("127.0.0.1", 8080); 
            // auth.useEmulator("http://127.0.0.1:9099"); 
        }
        
        console.log("Firebase initialized successfully");
    } else {
        console.warn("Firebase config missing. Please check your .env file.");
    }
} catch (error) {
    console.error("Firebase initialization error:", error);
}

// Export the initialized instances
export { db, auth, functions, analytics, firebase };